import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Shield } from 'lucide-react';
import { Button } from '../ui/Button';
import { useToast } from '../ui/Toast';
import { AnimatedSection } from './AnimatedSection';
export function FinalCtaSection() {
  const {
    success
  } = useToast();
  return <AnimatedSection className="py-8 sm:py-24 bg-slate-900" data-id="element-15927">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-15928">
        <motion.div animate={{
        rotate: [0, 10, -10, 0]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-15929">
          <Sparkles className="w-6 h-6 sm:w-8 sm:h-8 text-amber-400 mx-auto mb-4 sm:mb-6" data-id="element-15930" />
        </motion.div>
        <h2 className="text-lg sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-6" data-id="element-15931">
          Получите бесплатный мини-отчёт
        </h2>
        <p className="text-xs sm:text-lg text-slate-400 mb-5 sm:mb-10 max-w-2xl mx-auto" data-id="element-15932">
          Оставьте email, и мы пришлём краткий анализ вашей натальной карты.
        </p>
        <form className="flex flex-col sm:flex-row gap-2.5 sm:gap-3 justify-center max-w-lg mx-auto mb-4 sm:mb-6" data-id="element-15933">
          <input type="email" placeholder="Ваш email" className="px-4 sm:px-5 py-2.5 sm:py-3.5 rounded-xl bg-slate-800 border border-slate-700 text-white focus:outline-none focus:border-indigo-500 flex-grow text-xs sm:text-sm transition-colors" required data-id="element-15934" />
          <Button variant="outline" className="bg-white border-0 hover:bg-slate-100 text-xs sm:text-sm" size="lg" type="button" onClick={() => success('Спасибо! Мини-отчёт будет отправлен на ваш email.')} data-id="element-15935">
            Получить
          </Button>
        </form>
        <p className="text-[10px] sm:text-xs text-slate-500 flex items-center justify-center" data-id="element-15936">
          <Shield className="w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1 sm:mr-1.5" data-id="element-15937" /> Мы не
          рассылаем спам
        </p>
      </div>
    </AnimatedSection>;
}